import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import Vendor from '../../models/Vendor';


export interface VendorDetailState extends ApiState {
  vendor?: Vendor
}

export default requestReducer<VendorDetailState>('VENDOR_DETAIL')
